import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "max", "min", "placeholder"]

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DecimalNumberInput',
  props: {
    modelValue: {},
    placeholder: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const inputRef = ref<HTMLInputElement | null>(null);
const isFocused = ref(false);

/**
 * フォーカス状態を設定する
 * @param focused - フォーカス状態
 */
const setFocused = (focused: boolean): void => {
  isFocused.value = focused;
  if (!inputRef.value) return;
  inputRef.value.type = focused ? 'number' : 'text';
  if (!focused) {
    emits('update:modelValue', parseNumber(inputRef.value.value));
  }
};

/**
 * パースした数値を返す
 * バリデーションも行っており、値のMax/Minをチェックし、小数点以下6桁に制限する
 * @param value - Parseする値
 */
function parseNumber(value: string): number {
  let num = parseFloat(value.replace(/[^\d.-]/g, ''));
  if (isNaN(num)) return 0;
  if (num > Number.MAX_SAFE_INTEGER) num = Number.MAX_SAFE_INTEGER;
  if (num < Number.MIN_SAFE_INTEGER) num = Number.MIN_SAFE_INTEGER;
  return parseFloat(num.toFixed(6)); // 小数点以下6桁に制限
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    ref_key: "inputRef",
    ref: inputRef,
    value: _ctx.modelValue,
    step: 0.1,
    max: Number.MAX_SAFE_INTEGER,
    min: Number.MIN_SAFE_INTEGER,
    placeholder: props.placeholder,
    class: "decimal-number-input",
    onFocus: _cache[0] || (_cache[0] = () => setFocused(true)),
    onBlur: _cache[1] || (_cache[1] = ($event: any) => (setFocused(false)))
  }, null, 40, _hoisted_1))
}
}

})